
    // Buyer
    export const CREATE_BUYER = 'create_buyer';
    export const CREATE_BUYER_SUCCESS = 'create_buyer_success';
    export const CREATE_BUYER_FAIL = 'create_buyer_fail';

    export const FETCH_BUYERS = 'fetch_buyers';
    export const FETCH_BUYERS_SUCCESS = 'fetch_buyers_success';
    export const FETCH_BUYERS_FAIL = 'fetch_buyers_fail';

    export const SHOW_BUYER = 'show_buyer';
    export const SHOW_BUYER_SUCCESS = 'show_buyer_success';
    export const SHOW_BUYER_FAIL = 'show_buyer_fail';

    export const UPDATE_BUYER = 'update_buyer';
    export const UPDATE_BUYER_SUCCESS = 'update_buyer_success';
    export const UPDATE_BUYER_FAIL = 'update_buyer_fail';

    export const APPROVE_BUYER = 'approve_buyer';
    export const APPROVE_BUYER_SUCCESS = 'approve_buyer_success';
    export const APPROVE_BUYER_FAIL = 'approve_buyer_fail';

    export const REJECT_BUYER = 'reject_buyer';
    export const REJECT_BUYER_SUCCESS = 'reject_buyer_success';
    export const REJECT_BUYER_FAIL = 'reject_buyer_fail';

    // DEALS

    export const FETCH_DEALS = 'fetch_deals';
    export const FETCH_DEALS_SUCCESS = 'fetch_deals_success';
    export const FETCH_DEALS_FAIL = 'fetch_deals_fail';

    export const DEAL_UPDATE = 'deal_update';
    export const DEAL_UPDATE_SUCCESS = 'deal_update_success';
    export const DEAL_UPDATE_FAIL = 'deal_update_fail';

    // Seller
    export const CREATE_SELLER = 'create_seller';
    export const CREATE_SELLER_SUCCESS = 'create_seller_success';
    export const CREATE_SELLER_FAIL = 'create_seller_fail';

    export const CREATE_EXIT_AUDIT_SELLER = 'create_exit_audit_seller';
    export const CREATE_EXIT_AUDIT_SELLER_SUCCESS = 'create_exit_audit_seller_success';
    export const CREATE_EXIT_AUDIT_SELLER_FAIL = 'create_exit_audit_seller_fail';

    export const SCRAPE_SELLER_DATA = 'scrape_seller_data';
    export const SCRAPE_SELLER_DATA_SUCCESS = 'scrape_seller_data_success';
    export const SCRAPE_SELLER_DATA_FAIL = 'scrape_seller_data_fail';

    export const FETCH_SELLERS = 'fetch_sellers';
    export const FETCH_SELLERS_SUCCESS = 'fetch_sellers_success';
    export const FETCH_SELLERS_FAIL = 'fetch_sellers_fail';

    export const FETCH_SELLER_BUYERS = 'fetch_seller_buyers';
    export const FETCH_SELLER_BUYERS_SUCCESS = 'fetch_seller_buyers_success';
    export const FETCH_SELLER_BUYERS_FAIL = 'fetch_seller_buyers_fail';

    export const FETCH_ALL_SELLER_BUYERS_SUCCESS = 'fetch_all_seller_buyers_success';

    export const SHOW_SELLER = 'show_seller';
    export const SHOW_SELLER_SUCCESS = 'show_seller_success';
    export const SHOW_SELLER_FAIL = 'show_seller_fail';

    export const UPDATE_SELLER = 'update_seller';
    export const UPDATE_SELLER_SUCCESS = 'update_seller_success';
    export const UPDATE_SELLER_FAIL = 'update_seller_fail';

    export const GENERATE_SALES_DECK = 'generate_sales_deck';
    export const GENERATE_SALES_DECK_SUCCESS = 'generate_sales_deck_success';
    export const GENERATE_SALES_DECK_FAIL = 'generate_sales_deck_fail';

    export const SEND_CONFIDENTIALITY_AGREEMENT = 'send_confidentiality_agreement';
    export const SEND_CONFIDENTIALITY_AGREEMENT_SUCCESS = 'send_confidentiality_agreement_success';
    export const SEND_CONFIDENTIALITY_AGREEMENT_FAIL = 'send_confidentiality_agreement_fail';

    export const SEND_PRE_MEETING_DISCOVERY_EMAIL = 'send_pre_meeting_discovery_email';
    export const SEND_PRE_MEETING_DISCOVERY_EMAIL_SUCCESS = 'send_pre_meeting_discovery_email_success';
    export const SEND_PRE_MEETING_DISCOVERY_EMAIL_FAIL = 'send_pre_meeting_discovery_email_fail';

    export const SEND_VALUATION_REQUEST_EMAIL = 'send_valuation_request_email';
    export const SEND_VALUATION_REQUEST_EMAIL_SUCCESS = 'send_valuation_request_email_success';
    export const SEND_VALUATION_REQUEST_EMAIL_FAIL = 'send_valuation_request_email_fail';

    export const SYNC_GOOGLE_DRIVE = 'sync_google_drive';
    export const SYNC_GOOGLE_DRIVE_SUCCESS = 'sync_google_drive_success';
    export const SYNC_GOOGLE_DRIVE_FAIL = 'sync_google_drive_fail';

    export const SELLER_DEAL_STUDIO_SYNC = 'seller_deal_studio_sync';
    export const SELLER_DEAL_STUDIO_SYNC_SUCCESS = 'seller_deal_studio_sync_success';
    export const SELLER_DEAL_STUDIO_SYNC_FAIL = 'seller_deal_studio_sync_fail';
    
    // Drive File
    export const FETCH_DRIVE_FILES = 'fetch_drive_files';
    export const FETCH_DRIVE_FILES_SUCCESS = 'fetch_drive_files_success';
    export const FETCH_DRIVE_FILES_FAIL = 'fetch_drive_files_fail';

    // EXIT AUDTIS

    export const SHOW_EXIT_AUDIT = 'show_exit_audit';
    export const SHOW_EXIT_AUDIT_SUCCESS = 'show_exit_audit_success';
    export const SHOW_EXIT_AUDIT_FAIL = 'show_exit_audit_fail';

    // Dataroom

    export const UPDATE_DATAROOM = 'update_dataroom';
    export const UPDATE_DATAROOM_SUCCESS = 'update_dataroom_success';
    export const UPDATE_DATAROOM_FAIL = 'update_dataroom_fail';
    
    // Exit Navigator

    export const UPDATE_EXIT_NAVIGATOR = 'update_exit_navigator';
    export const UPDATE_EXIT_NAVIGATOR_SUCCESS = 'update_exit_navigator_success';
    export const UPDATE_EXIT_NAVIGATOR_FAIL = 'update_exit_navigator_fail';

    export const GENERATE_EXIT_NAVIGATOR = 'generate_exit_navigator';
    export const GENERATE_EXIT_NAVIGATOR_SUCCESS = 'generate_exit_navigator_success';
    export const GENERATE_EXIT_NAVIGATOR_FAIL = 'generate_exit_navigator_fail';

    // Breakwater Drive

    export const UPDATE_BREAKWATER_DRIVE = 'update_breakwater_drive';
    export const UPDATE_BREAKWATER_DRIVE_SUCCESS = 'update_breakwater_drive_success';
    export const UPDATE_BREAKWATER_DRIVE_FAIL = 'update_breakwater_drive_fail';

    // Rag Store

    export const UPDATE_RAG_STORE = 'update_rag_store';
    export const UPDATE_RAG_STORE_SUCCESS = 'update_rag_store_success';
    export const UPDATE_RAG_STORE_FAIL = 'update_rag_store_fail';

    // Auth

    export const SYNC_STYTCH_AUTH = 'sync_stytch_auth';
    export const SYNC_STYTCH_AUTH_SUCCESS = 'sync_stytch_auth_success';
    export const SYNC_STYTCH_AUTH_FAIL = 'sync_stytch_auth_fail';

    // Employee
    export const SHOW_EMPLOYEE = 'show_employee';
    export const SHOW_EMPLOYEE_SUCCESS = 'show_employee_success';
    export const SHOW_EMPLOYEE_FAIL = 'show_employee_fail';
    export const UPDATE_PARTNER_SETTINGS = 'update_partner_settings';
    export const UPDATE_PARTNER_SETTINGS_SUCCESS = 'update_partner_settings_success';
    export const UPDATE_PARTNER_SETTINGS_FAIL = 'update_partner_settings_fail';
    export const SET_SIMULATED_PARTNER = 'set_simulated_partner';
    export const CLEAR_SIMULATED_PARTNER = 'clear_simulated_partner';

    // Partner
    export const FETCH_PARTNERS = 'fetch_partners';
    export const FETCH_PARTNERS_SUCCESS = 'fetch_partners_success';
    export const FETCH_PARTNERS_FAIL = 'fetch_partners_fail';

    export const CREATE_PARTNER = 'create_partner';
    export const CREATE_PARTNER_SUCCESS = 'create_partner_success';
    export const CREATE_PARTNER_FAIL = 'create_partner_fail';

    // Dealroom Analytics
    export const FETCH_SELLER_DEALROOM_ANALYTICS = 'fetch_seller_dealroom_analytics';
    export const FETCH_SELLER_DEALROOM_ANALYTICS_SUCCESS = 'fetch_seller_dealroom_analytics_success';
    export const FETCH_SELLER_DEALROOM_ANALYTICS_FAIL = 'fetch_seller_dealroom_analytics_fail';

    export const FETCH_BUYER_DEALROOM_ANALYTICS = 'fetch_buyer_dealroom_analytics';
    export const FETCH_BUYER_DEALROOM_ANALYTICS_SUCCESS = 'fetch_buyer_dealroom_analytics_success';
    export const FETCH_BUYER_DEALROOM_ANALYTICS_FAIL = 'fetch_buyer_dealroom_analytics_fail';

    // Buyer Outreach
    export const FETCH_BUYER_OUTREACH = 'fetch_buyer_outreach';
    export const FETCH_BUYER_OUTREACH_SUCCESS = 'fetch_buyer_outreach_success';
    export const FETCH_BUYER_OUTREACH_FAIL = 'fetch_buyer_outreach_fail';

    export const UPDATE_BUYER_OUTREACH = 'update_buyer_outreach';
    export const UPDATE_BUYER_OUTREACH_SUCCESS = 'update_buyer_outreach_success';
    export const UPDATE_BUYER_OUTREACH_FAIL = 'update_buyer_outreach_fail';
